import { Link } from 'react-router-dom';
import useIsMobile from '../../lib/useIsMobile';

const C = {
  bg: '#1B2B4B',
  white: '#FFFFFF',
  muted: '#94A3B8',
  border: '#334155',
};

export default function Footer() {
  const isMobile = useIsMobile();

  return (
    <footer style={{ background: C.bg, padding: isMobile ? '40px 24px 30px' : '60px 24px 40px' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : '2fr 1fr 1fr 1fr',
          gap: isMobile ? 32 : 48,
          marginBottom: isMobile ? 32 : 48,
        }}>
          <div>
            <div style={{ fontSize: 20, fontWeight: 800, color: C.white, marginBottom: 16, fontFamily: "'Georgia', serif" }}>ClearSeg</div>
            <p style={{ color: C.muted, fontSize: 14, lineHeight: 1.7, margin: 0, maxWidth: 280 }}>
              PE-certified cost segregation studies for rental property owners. $799. Delivered in 2 weeks.
            </p>
          </div>

          <div>
            <h4 style={{ color: C.white, fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16, marginTop: 0 }}>Company</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link to="/" style={{ color: C.muted, textDecoration: 'none', fontSize: 14 }}>Home</Link>
              <Link to="/faq" style={{ color: C.muted, textDecoration: 'none', fontSize: 14 }}>FAQ</Link>
              <Link to="/intake" style={{ color: C.muted, textDecoration: 'none', fontSize: 14 }}>Start a Study</Link>
              <Link to="/calculator" style={{ color: C.muted, textDecoration: 'none', fontSize: 14 }}>Savings Calculator</Link>
              <Link to="/blog" style={{ color: C.muted, textDecoration: 'none', fontSize: 14 }}>Blog</Link>
              <Link to="/partners" style={{ color: C.muted, textDecoration: 'none', fontSize: 14 }}>Partner Program</Link>
            </div>
          </div>

          <div>
            <h4 style={{ color: C.white, fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16, marginTop: 0 }}>Portal</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <Link to="/login" style={{ color: C.muted, textDecoration: 'none', fontSize: 14 }}>Login</Link>
              <Link to="/engineer" style={{ color: C.muted, textDecoration: 'none', fontSize: 14 }}>Engineer Portal</Link>
            </div>
          </div>

          <div>
            <h4 style={{ color: C.white, fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 16, marginTop: 0 }}>Contact</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <a href="mailto:info@clearseg.com" style={{ color: C.muted, fontSize: 14, textDecoration: 'none' }}>info@clearseg.com</a>
              <a href="tel:+16465331623" style={{ color: C.muted, fontSize: 14, textDecoration: 'none' }}>(646) 533-1623</a>
            </div>
          </div>
        </div>

        <div style={{
          borderTop: `1px solid ${C.border}`, paddingTop: 24,
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          alignItems: isMobile ? 'center' : 'center',
          gap: isMobile ? 8 : 0,
          textAlign: isMobile ? 'center' : 'left',
        }}>
          <span style={{ color: C.muted, fontSize: 13 }}>&copy; 2026 ClearSeg. All rights reserved.</span>
          <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
            <Link to="/privacy" style={{ color: C.muted, fontSize: 13, textDecoration: 'none' }}>Privacy Policy</Link>
            <Link to="/terms" style={{ color: C.muted, fontSize: 13, textDecoration: 'none' }}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
